"use client";

import { Button } from "@/components/ui/Button";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

type PaginationProps = {
  page: number;
  totalPages: number;
  setPage: (page: number) => void;
};

export function Pagination({ page, totalPages, setPage }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <nav
      aria-label="Stránkování článků"
      className="flex items-center justify-center gap-3 pt-8"
    >
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => setPage(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="Předchozí stránka"
      >
        <ChevronLeftIcon aria-hidden className="size-4" />
      </Button>
      <span className="min-w-20 text-center text-sm tabular-nums text-foreground/70">
        {page} / {totalPages}
      </span>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => setPage(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        aria-label="Další stránka"
      >
        <ChevronRightIcon aria-hidden className="size-4" />
      </Button>
    </nav>
  );
}
